export default "__VITE_PUBLIC_ASSET__cc094cd2__"